export enum DATA_QA {
  ROOT = 'csv-import-upload-step',
  CONTINUE = 'csv-import-upload-step__continue',
}
